// extracted by mini-css-extract-plugin
export var li = "_vd-2";
export var ol = "_vd-1";
export var ul = "_vd-0";